import { inputStyles } from '@/styles/input';
import { cn } from '@/utils/cn';

interface InputProps {
  type?: string;
  placeholder: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  className?: string;
  error?: string;
  renderIcon?: () => React.ReactNode;
  onBlur?: () => void;
  disabled?: boolean;
  maxLength?: number;
  inputMode?: React.HTMLAttributes<HTMLInputElement>['inputMode'];
  onFocus?: () => void;
}

export const Input = ({
  type,
  placeholder,
  value,
  onChange,
  className,
  error,
  renderIcon,
  onBlur,
  disabled,
  maxLength,
  inputMode,
  onFocus,
}: InputProps) => {
  const testId = `input-${placeholder.toLowerCase().replace(/\s+/g, '-')}`;
  return (
    <div className="flex flex-col gap-1 w-full">
      <div className="relative w-full">
        <input
          data-testid={testId}
          type={type}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          onFocus={onFocus}
          disabled={disabled}
          maxLength={maxLength}
          inputMode={inputMode}
          className={cn(
            inputStyles,
            className,
            renderIcon && 'w-full focus:border-muted-foreground active:border-muted-foreground',
            error && 'border-danger text-danger active:border-danger focus:border-danger'
          )}
        />
        {renderIcon && (
          <div className="absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none">{renderIcon()}</div>
        )}
      </div>
      {error && (
        <div data-testid={`${testId}-error`} className="text-xs text-red-500 min-h-[1.25rem]">
          {error}
        </div>
      )}
    </div>
  );
};
